import Navbar from '../Navbar';
import Header from '../Header';
import GifSection from '../Gifsection';


function Main() {


  return (
    <>
      <Navbar />
      <Header />
      <GifSection />

    </>
  );
}

export default Main;
